import { cohortResDto } from '@web/common';
import { authenticatedAPI } from '../AuthenticatedAPI';
import { z } from 'zod';

export const getCohorts = async () => {
  return authenticatedAPI.get(`/api/cohort`, z.array(cohortResDto));
};
